const SUBCATEGORY_LABEL_OVERRIDES = {
  iPad: "iPads",
};

export const formatSubcategoryLabel = (name) => {
  if (typeof name !== "string" || !name.trim()) return name;
  return SUBCATEGORY_LABEL_OVERRIDES[name] || name;
};

/** Merge category-level and subcategory field defs for spec/icon lookup. */
export const mergeCategoryFieldDefs = (category = {}) => {
  const byName = new Map();

  const addFields = (list) => {
    (list || []).forEach((field) => {
      const key = String(field?.name || "").toLowerCase();
      if (!key) return;
      const existing = byName.get(key);
      if (!existing) {
        byName.set(key, field);
        return;
      }
      if (!existing.icon && field.icon) {
        byName.set(key, { ...existing, icon: field.icon });
      }
    });
  };

  addFields(category.fields);
  (category.subcategories || []).forEach((sub) => addFields(sub.fields));
  return Array.from(byName.values());
};
